module.exports = "/_next/static/images/d55d9df333f68ff4adb2a95322ca91fa-nucommunity-xs@3x.jpg.webp";